module.exports = __webpack_public_path__ + "img/arrow-left.0659d8c3.svg";